export const DB_PREFIX_JOBS = 'jobRoles';
export const DB_PREFIX_QUALIFICATIONS = 'qualifications';
export const TITLE = 'Job Roles & Qualifications';
export const DESCRIPTION = 'Relevant skills and experience.';
